import Badge, { BadgeColor } from '../../Badge'

interface Props {
  isActive?: boolean
  text?: string
  activeColor?: BadgeColor
  inActiveColor?: BadgeColor
}

const StatusCell = ({ isActive, text, activeColor = 'green', inActiveColor = 'gray' }: Props) => {
  const displayText = text ?? (isActive ? 'Active' : 'Deactivated')
  const color = isActive ? activeColor : inActiveColor
  if (typeof isActive === 'undefined') return <></>
  return <Badge color={color} text={displayText} />
}

export default StatusCell
